import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class SubContractorStatusWiseCountResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    constructor(status: boolean, intlCode: number, internalMessage: string, active?: number,inActive?:number){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.active = active;
        this.inActive=inActive;
    }
}

